
<style lang="scss" scoped>

    .cityads .cards {
        .title {
            color: var(--v-secondary-base);
            font-size: 36px !important;
            font-weight: 700;
            line-height: 49px;
            letter-spacing: 0em;
        }
        .text {
            /* font-family: Open Sans; */
            font-size: 20px;
            font-weight: 400;
            line-height: 27px;
            letter-spacing: 0em;
        }
    }
    
</style>

<template>
    <div class="cards text-center">
        <div class="mt-4">
            <img src="../../assets/free.png" />
            <p class="title">0%</p>
            <p class="text">Бесплатный займ</p>
        </div>
        <div v-if="$vuetify.breakpoint.lgAndUp" class="mt-4">
            <img src="../../assets/easily-outline.png" />
            <p class="title">Просто</p>
            <p class="text">Без доп. услуг и подписок</p>
        </div>
        <div v-if="$vuetify.breakpoint.lgAndUp" class="mt-4">
            <img src="../../assets/comfortably-outline.png" />
            <p class="title">Удобно</p>
            <p class="text">Досрочное погашение</p>
        </div>
    </div>
</template>

<script>
    export default {}
</script>
